import type { CurrencyCode } from "./types";

export type Currency = {
  code: CurrencyCode;
  symbol: string;
  label: string;
  position: "before" | "after";
};

export const currencies: Currency[] = [
  { code: "USD", symbol: "$", label: "US Dollar", position: "before" },
  { code: "EUR", symbol: "€", label: "Euro", position: "before" },
  { code: "GBP", symbol: "£", label: "British Pound", position: "before" },
  { code: "CAD", symbol: "C$", label: "Canadian Dollar", position: "before" },
  { code: "AUD", symbol: "A$", label: "Australian Dollar", position: "before" },
  { code: "INR", symbol: "₹", label: "Indian Rupee", position: "before" },
  { code: "AED", symbol: "د.إ", label: "UAE Dirham", position: "after" },
  { code: "SAR", symbol: "ر.س", label: "Saudi Riyal", position: "after" },
  { code: "JPY", symbol: "¥", label: "Japanese Yen", position: "before" },
];

export function getCurrency(code: CurrencyCode) {
  return currencies.find((currency) => currency.code === code) ?? currencies[0];
}

export function formatMoney(value: number, code: CurrencyCode) {
  const currency = getCurrency(code);
  const amount = value.toLocaleString("en-US", {
    minimumFractionDigits: code === "JPY" ? 0 : 2,
    maximumFractionDigits: code === "JPY" ? 0 : 2,
  });

  return currency.position === "before"
    ? `${currency.symbol}${amount}`
    : `${amount} ${currency.symbol}`;
}
